<template>
  <div class="card">
    <div class="row no-gutters">
      <div class="col-md-4 image-wrapper">
        <img :src="image.url" class="card-img" alt="" />
        <div class="img-actions">
          <div class="edit action">
            <svg width="50pt" height="50pt" viewBox="0 0 50 50" version="1.1">
              <path
                d="M 7.8125 6.25 C 5.226563 6.25 3.125 8.347656 3.125 10.9375 L 3.125 39.0625 C 3.125 41.648438 5.226563 43.75 7.8125 43.75 L 23.15625 43.75 L 23.902344 40.625 L 7.8125 40.625 C 6.945313 40.625 6.25 39.929688 6.25 39.0625 L 6.25 36.167969 L 17.359375 23.644531 L 28.515625 35.414063 L 30.710938 33.191406 L 28.855469 31.226563 L 32.859375 26.707031 L 34.9375 28.882813 L 37.121094 26.660156 L 32.800781 22.082031 L 26.695313 28.953125 L 17.285156 19.03125 L 6.25 31.457031 L 6.25 10.9375 C 6.25 10.070313 6.945313 9.375 7.8125 9.375 L 42.1875 9.375 C 43.054688 9.375 43.75 10.070313 43.75 10.9375 L 43.75 21.949219 C 43.957031 21.921875 44.164063 21.875 44.371094 21.875 L 44.53125 21.875 C 45.359375 21.921875 46.140625 22.09375 46.875 22.363281 L 46.875 10.9375 C 46.875 8.347656 44.773438 6.25 42.1875 6.25 Z M 34.375 12.5 C 32.652344 12.5 31.25 13.902344 31.25 15.625 C 31.25 17.347656 32.652344 18.75 34.375 18.75 C 36.097656 18.75 37.5 17.347656 37.5 15.625 C 37.5 13.902344 36.097656 12.5 34.375 12.5 Z M 44.382813 25.011719 C 43.371094 25.023438 42.359375 25.414063 41.601563 26.195313 L 27.027344 41.015625 L 24.851563 50.148438 L 33.984375 47.984375 L 34.289063 47.667969 L 48.816406 33.398438 C 50.367188 31.882813 50.390625 29.332031 48.839844 27.796875 L 47.203125 26.148438 C 46.4375 25.378906 45.410156 25 44.382813 25.011719 Z M 44.410156 28.113281 C 44.617188 28.113281 44.824219 28.199219 44.996094 28.367188 L 46.628906 30.003906 C 46.972656 30.335938 46.972656 30.835938 46.628906 31.175781 L 32.421875 45.128906 L 29.050781 45.945313 L 29.859375 42.578125 L 43.835938 28.367188 C 43.992188 28.199219 44.203125 28.113281 44.410156 28.113281 Z "
              />
            </svg>
            <input
              type="file"
              style="opacity: 0"
              @change="
                $emit('editImage', { image, file: $event.target.files[0] })
              "
            />
          </div>
          <div class="delete action" @click="$emit('deleteCard', image)">
            <svg width="52pt" height="52pt" viewBox="0 0 52 52">
              <path
                d="M 23 -0.0625 C 19.085938 -0.0625 15.9375 3.1875 15.9375 7.125 L 15.9375 8 L 8 8 C 6.898438 8 6 8.898438 6 10 L 6 12 L 4 12 L 4 16 L 8 16 L 8 46 C 8 49.289063 10.710938 52 14 52 L 38 52 C 41.289063 52 44 49.289063 44 46 L 44 16 L 48 16 L 48 12 L 46 12 L 46 10 C 46 8.898438 45.101563 8 44 8 L 36.0625 8 L 36.0625 7.125 C 36.0625 3.1875 32.914063 -0.0625 29 -0.0625 Z M 23 4.0625 L 29 4.0625 C 30.609375 4.0625 31.9375 5.375 31.9375 7.125 L 31.9375 8 L 20.0625 8 L 20.0625 7.125 C 20.0625 5.375 21.390625 4.0625 23 4.0625 Z M 12 16 L 22.25 16 C 22.5 16.023438 22.742188 16.0625 23 16.0625 L 29 16.0625 C 29.257813 16.0625 29.5 16.023438 29.75 16 L 40 16 L 40 46 C 40 47.125 39.125 48 38 48 L 14 48 C 12.875 48 12 47.125 12 46 Z M 16 20 L 16 44 L 20 44 L 20 20 Z M 24 20 L 24 44 L 28 44 L 28 20 Z M 32 20 L 32 44 L 36 44 L 36 20 Z "
              />
            </svg>
          </div>
        </div>
      </div>
      <div class="col-md-8">
        <div
          class="card-body"
          :class="{
            active: marked
          }"
        >
          <input
            type="text"
            v-model.trim="projectName"
            class="card-text"
            @keypress.enter="sendNewName"
          />
          <p class="card-text">
            <small class="text-muted"
              >Last updated {{ image.createdOn.seconds | date }}</small
            >
          </p>
          <p class="card-text">
            <small class="text-muted">{{ image.name }}</small>
          </p>
          <div class="card-actions">
            <p class="mark-delete" @click="$emit('addToBulkDelete', image)">
              {{ marked ? "MARKED FOR DELETE" : "MARK FOR DELETE" }}
            </p>
            <p
              class="edit"
              @click="sendNewName"
              :class="{ editable: projectName }"
            >
              EDIT
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    image: {
      type: Object
    },
    marked: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      projectName: this.image.project
    };
  },
  methods: {
    sendNewName() {
      if (!this.projectName) {
        return alert("You cannot save a blank name");
      }
      const updatedImage = {
        image: this.image,
        project: this.projectName
      };
      let confirm = window.confirm(
        "Are you sure you want to change " +
          this.image.project +
          " to " +
          this.projectName
      );
      if (confirm) {
        this.$emit("updateName", updatedImage);
      }
    }
  },
  filters: {
    date(value) {
      if (!value) return "";
      return new Date(value * 1000).toString().split("GMT")[0];
    }
  }
};
</script>

<style lang="scss" scoped>
.card {
  background: black;
  animation: slide-up 0.8s ease forwards;

  @keyframes slide-up {
    from {
      transform: translateY(100%);
    }
  }

  .card-body {
    height: 100%;

    input {
      background: none;
      border: none;
      color: rgba(white, 0.5);
      width: 100%;

      &::placeholder {
        opacity: 1;
      }

      &::selection {
        background-color: $primary;
      }
    }

    &.active {
      background: rgba($primary, 0.3);
    }

    .card-actions {
      font-size: 0.8rem;
      font-weight: 700;
      display: flex;
      flex-flow: row wrap;
      cursor: pointer;

      .mark-delete {
        color: $primary;
        margin-right: 20px;
      }

      .editable {
        color: green;
      }
    }
  }

  .image-wrapper {
    position: relative;
    overflow: hidden;

    .card-img {
      width: 100%;
      height: 250px;
      object-fit: cover;

      @media (min-width: 794px) {
        height: 100%;
        position: absolute;
      }
    }

    .img-actions {
      position: absolute;
      bottom: 10px;
      left: 50%;
      transform: translateX(-50%);
      display: grid;
      grid-auto-flow: column;
      grid-gap: 10px;

      .action {
        border-radius: 50%;
        width: 40px;
        height: 40px;
        display: grid;
        place-items: center;
        cursor: pointer;
        overflow: hidden;

        &.delete {
          background: brown;
        }

        &.edit {
          background: green;
          position: relative;

          svg {
            position: absolute;
          }
        }

        svg {
          fill: #f5f5f5;
          height: 15px;
          width: 15px;
        }
      }
    }
  }
}
</style>
